import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { UserPerceivedLoadTimingContext } from "@faire/web--source/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import { useWaitForImagesToLoad } from "@faire/web--source/common/performance/useWaitForImagesToLoad/useWaitForImagesToLoad";
import React from "react";
import { SDUISectionRenderer } from "@faire/retailer/components/SDUI/__internal__/SDUISectionRenderer/SDUISectionRenderer";
var IMAGE_PERCENTAGE_REMAINING = 0.1;
var IMAGE_COUNT_REMAINING = 1;
var IMAGE_LOADING_TIMEOUT = 7000;
export var SDUIRenderer = function(param) {
    var componentRenderers = param.componentRenderers, sectionRenderers = param.sectionRenderers, viewLayout = param.viewLayout, UPLTprops = param.UPLTprops, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var _React_useState = _sliced_to_array(React.useState(UPLTprops === null || UPLTprops === void 0 ? void 0 : UPLTprops.shouldRenderBelowTheFold), 2), shouldRenderBelowTheFold = _React_useState[0], setShouldRenderBelowTheFold = _React_useState[1];
    var upltNumComponents = React.useContext(UserPerceivedLoadTimingContext).numComponents;
    var handleRenderBelowTheFold = function() {
        React.startTransition(function() {
            setShouldRenderBelowTheFold(true);
        });
    };
    var waitForImagesToLoadRef = useWaitForImagesToLoad({
        numComponents: upltNumComponents !== null && upltNumComponents !== void 0 ? upltNumComponents : Infinity,
        onImageLoad: function(numImagesPending, totalNumImages) {
            if (numImagesPending < IMAGE_COUNT_REMAINING || numImagesPending / totalNumImages < IMAGE_PERCENTAGE_REMAINING) {
                handleRenderBelowTheFold();
            }
        },
        onTimeout: handleRenderBelowTheFold,
        timeout: IMAGE_LOADING_TIMEOUT
    });
    var layoutElementRef = !(UPLTprops === null || UPLTprops === void 0 ? void 0 : UPLTprops.shouldRenderBelowTheFold) ? waitForImagesToLoadRef : undefined;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: viewLayout.content.map(function(section) {
            return /*#__PURE__*/ _jsx(SDUISectionRenderer, {
                section: section,
                sectionRenderers: sectionRenderers,
                componentRenderers: componentRenderers,
                viewLoggingData: viewLayout.logging_data,
                loadTimingRef: layoutElementRef,
                UPLTprops: UPLTprops,
                shouldRenderBelowTheFold: shouldRenderBelowTheFold,
                onClickClientDismissHandler: onClickClientDismissHandler
            }, section.id);
        })
    });
};
